
export const BackBtn = ({ onClick }) => {
    return (
        <button className={`back-btn`} onClick={onClick}>
            <img src="/assets/icons/back.svg" className="header-back" alt={""} />
        </button>
    )
}